import React, { Component } from 'react'
import {View, StyleSheet, Platform} from 'react-native'
import { JDText, JDImage, JDDevice, JDTouchable} from '@jdreact/jdreact-core-lib'
import PropTypes from 'prop-types'
import { imgProcess } from '../../../utils/tools'

export default class LoupanCard extends Component {
	static propTypes = {
		loupanData: PropTypes.object,
	};

	render() {
		const {
			mainImage, // 主图
			name, // 房源标题
			countyName,
			streetName,
			address,
		} = this.props.loupanData || {};
		return (
				<View style={houseItemStyles.houseBox}>
					<View>
						<JDImage source={{uri: imgProcess(mainImage)}} style={houseItemStyles.houseImg}></JDImage>
					</View>
					<View style={houseItemStyles.houseInfo}>
						<JDText style={houseItemStyles.houseTitle} numberOfLines={2}>{name}</JDText>
						<JDText style={houseItemStyles.featureWrap}>
								<JDText style={houseItemStyles.featureItem}>{countyName + (streetName ? '-' + streetName : '')}</JDText>
						</JDText>
						<View style={houseItemStyles.featureWrap}>
							<JDText style={houseItemStyles.featureItem}>{address}</JDText>
						</View>
					</View>
				</View>
		)
	}
}
const houseItemStyles = StyleSheet.create({
	houseBox: {
		position: 'relative',
		flexDirection: 'row',
		paddingHorizontal: JDDevice.getRpx(30),
		paddingBottom: JDDevice.getRpx(40),
	},
	houseImg: {
		width: JDDevice.getRpx(240),
		height: JDDevice.getRpx(184),
		borderRadius: JDDevice.getRpx(12),
	},
	houseInfo: {
		flex:1,
		paddingLeft: JDDevice.getRpx(24),
		backgroundColor: "#fff",
	},
	houseTitle: {
		marginTop: JDDevice.getRpx(3),
		marginBottom: JDDevice.getRpx(18),
		fontSize: JDDevice.getRpx(36),
		fontFamily: 'PingFang SC',
		fontWeight: "500",
		color: '#1A1A1A'
	},
	featureWrap: {
		marginBottom: JDDevice.getRpx(18),
	},
	featureItem: {
		lineHeight:JDDevice.getRpx(28),
		fontSize: JDDevice.getRpx(24),
		fontWeight:'normal',
		flexShrink:0,
		color: '#555555',
	},
	
});